import { PromiseClient } from 'hub-http/adapters/promiseClient';
import { useContext } from 'react';
import { createRpcClientV2, RpcClientV2 } from 'rpc-client-utils';
import memoize from 'transmute/memoize';

import { HttpClientContext } from './HttpClientContext';

const getRpcClient = memoize((hubHttpClient: PromiseClient) =>
  createRpcClientV2({ hubHttpClient })
);

export function useRpcClient(): RpcClientV2 {
  const hubHttpClient = useContext(HttpClientContext);
  return getRpcClient(hubHttpClient);
}
